import React, { Component } from 'react'
import { Col, Container, Row } from 'reactstrap'
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import InfiniteScroll from "react-infinite-scroll-component";
import { observer } from 'mobx-react'
import LoadingImage from '../../../comum/components/LoadingImage';
import CardConsulta from './CardConsulta';

@observer
export default class TabelaConsulta extends Component {

    constructor(props) {
        super(props)

        this.controller = this.props.controller
    }

    render() {
        if(this.controller.tableMessage !== "") {
            return (
                <Row>
                    <Col xs={12}>
                        <span className="mensagem-filtrar">
                            {this.controller.tableMessage}
                        </span>
                    </Col>
                </Row>
            )
        } else if(this.controller.loading) {
            return (
                <Row>
                    <Col xs={12}>
                        <LoadingImage />
                    </Col>
                </Row>
            )
        } else {
            return (<Container fluid className="tabela-container">
                <InfiniteScroll
                    dataLength={this.controller.itens.length}
                    next={() => this.controller.loadNextTurn()}
                    hasMore={this.controller.hasMore}
                    loader={<LoadingImage />}
                >
                    {
                        window.innerWidth > 991
                        ?<ToolkitProvider
                            keyField="Id"
                            data={[...this.controller.itens]}
                            columns={[...this.controller.colunas]}
                        >
                            {
                                props => <div>
                                    <BootstrapTable boostrap4
                                        stripped
                                        bordered={false}
                                        classes="tabela tabela-layout cabotagem"
                                        {...props.baseProps}
                                    />
                                </div>
                            }
                        </ToolkitProvider>
                        :this.controller.itens.map(item => {
                            return(
                                <CardConsulta
                                    key={item.Id}
                                    controller={this.controller}
                                    data={item}
                                    id={item.Id}
                                    colunas={[...this.controller.colunas]}
                                    //outrosDados={[...this.controller.outrosDados]}
                                    titulo={"Id"}
                                />
                            )
                        })
                    }
                </InfiniteScroll>
            </Container>
            )
        }
    }
}



// WEBPACK FOOTER //
// ./src/modules/faturamento/consulta/components/TabelaConsulta.js